import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";

interface FilterParams{
    isDropdown: boolean
}

interface SowItem{
    sowID: string,
    sowName: string
}

const fetchSOWSbySupplierCode = async (supplierCode: string, filterparams?:FilterParams ):Promise<SowItem[]> => {
    const sow = await apiInputService.get(`/Sow/supplierCode/${supplierCode}`,{
        params: {
            ...filterparams
        }
    })
    
    const { data } = sow;

    return data;
}


export const useSOWSbySupplierCode = (supplierCode: string, filterparams?:FilterParams, options?: any) => {
    return useQuery<any[]>(["sow", supplierCode, Object.values(filterparams || {} )], () => fetchSOWSbySupplierCode(supplierCode), {
        enabled:!!supplierCode,
        ...options,
        
    });
}